export default __webpack_public_path__ + "static/PH_Logo_BLACK-8ece33f0d94888fd5015fd834c8cafec.jpg";